<mat-drawer-container id="customers_add_edit_main_container" autosize>
  <mat-card id="customers_add_edit_mat_card">
    <mat-card-content class="form-mat-card-content">
      @if (!loading() && !formPrepareError()) {
        <form
          id="customer_idp_form"
          class="custom-form grid-form custom-form-in-tab"
          autocomplete="off"
          [formGroup]="customerIdpForm">
          <mat-form-field class="you-cant-see-me">
            <input #focusTrap matInput />
          </mat-form-field>
          <div class="span-all-cols div-icon">
            <div id="form_input_title_redirect" class="form-input-title">Redirect URI:</div>
            <mat-form-field id="form_field_redirect" class="form-field-custom form-field-input">
              <input
                matInput
                id="form_field_input_redirect"
                class="shared-input-field"
                autocomplete="off"
                [disabled]="true"
                [value]="redirectUri()" />
            </mat-form-field>
            <button
              #copyTooltip="matTooltip"
              type="button"
              class="pointer copy-icon"
              matTooltip="Copied!"
              [matTooltipDisabled]="true"
              (click)="copyRedirectUri(copyTooltip)">
              <i class="fas fa-copy"></i>
            </button>
            <span class="error-space-holder"> </span>
          </div>

          <div class="span-all-cols">
            <div id="form_input_title_client_id" class="form-input-title">Discovery URL:</div>
            <span class="input-with-button">
              <mat-form-field
                id="form_field_client_id"
                class="form-field-custom form-field-input"
                formGroupName="identityProviderConfigDTO">
                <input
                  matInput
                  id="form_field_input_client_id"
                  class="shared-input-field"
                  autocomplete="off"
                  formControlName="discoveryUrl" />
              </mat-form-field>
              <button
                mat-button
                id="customers_add_edit_cancel"
                class="white-button"
                (click)="
                  testConnection(
                    customerIdpForm.get('identityProviderConfigDTO.discoveryUrl')?.value
                  )
                ">
                Test Connection
              </button>
            </span>
            <span id="meta_info" class="error-space-holder meta-info">
              The 5 endpoints below are read directly from this URL - nothing to fill in.
            </span>
            <span id="metadata_text" class="meta-text pointer" (click)="openBox()">
              <span class="meta-icon" [class.rotated]="isBoxOpen()">❯</span>
              Metadata
            </span>
            <div class="expansion-box" [class.open]="isBoxOpen()">
              <div class="expansion-content" formGroupName="identityProviderConfigDTO">
                <ng-template
                  #readonlyField
                  let-label="label"
                  let-id="id"
                  let-formControlName="formControlName">
                  <div class="expansion-div">
                    <div class="form-input-title" [id]="id + '_title'">{{ label }}</div>
                    <mat-form-field class="form-field-custom form-field-input" [id]="id + '_field'">
                      <input
                        matInput
                        class="shared-input-field box-input default"
                        autocomplete="off"
                        [formControlName]="formControlName"
                        [id]="id + '_input'" />
                    </mat-form-field>
                  </div>
                </ng-template>

                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'Authorisation URL',
                      id: 'auth_url',
                      formControlName: 'authorizationUrl',
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'Token URL',
                      id: 'token_url',
                      formControlName: 'tokenUrl',
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'Logout URL',
                      id: 'logout_url',
                      formControlName: 'logoutUrl',
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'User Info URL',
                      id: 'user_info_url',
                      formControlName: 'userInfoUrl',
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'Issuer URL',
                      id: 'issuer_url',
                      formControlName: 'issuer',
                    }
                  "></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    readonlyField;
                    context: {
                      label: 'JWKS URL',
                      id: 'jwks_url',
                      formControlName: 'jwksUrl',
                    }
                  "></ng-container>
              </div>
            </div>
            <span class="error-space-holder"></span>
          </div>

          <span id="deatils_header" class="section-header">API Details</span>
          <div class="span-all-cols"><hr /></div>

          <div class="span-all-cols">
            <div id="form_input_title_client_auth" class="form-input-title">
              Client Authentication:
            </div>
            <mat-form-field id="client_auth_field" class="form-field-custom add-edit-dropdown">
              <mat-select
                id="prompt_select"
                placeholder="Select Client Authentication"
                formControlName="clientAuthentication">
                @for (option of clientAuthOptions; track option.value) {
                  <mat-option id="prompt_option{{ option }}" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="error-space-holder"></span>
          </div>

          <div class="span-all-cols">
            <div id="form_input_title_client_id" class="form-input-title">
              Client ID: <span class="red-star">*</span>
            </div>
            <mat-form-field id="form_field_client_id" class="form-field-custom form-field-input">
              <input
                matInput
                id="form_field_input_client_id"
                class="shared-input-field"
                formControlName="clientId"
                autocomplete="off"
                (focus)="onInputFocus('clientId')"
                (blur)="onInputBlur('clientId'); trimField('clientId')" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                customerIdpForm.controls['clientId'].touched &&
                customerIdpForm.controls['clientId'].errors !== null &&
                !focusState()['clientId']
              ) {
                <mat-error id="client_id_secret" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i>
                  Client ID is Required
                </mat-error>
              }
            </span>
          </div>

          <div class="span-all-cols div-icon">
            <div id="form_input_title_client_secret" class="form-input-title">
              Client Secret: <span class="red-star">*</span>
            </div>
            <mat-form-field
              id="form_field_client_secret"
              class="form-field-custom form-field-input">
              <input
                matInput
                id="form_field_input_client_secret"
                class="shared-input-field"
                formControlName="clientSecret"
                autocomplete="off"
                [class.hide-password]="customerIdpForm.get('clientSecret')?.value === secretBackUp"
                (focus)="onInputFocus('clientSecret')"
                (input)="editSecret()"
                (blur)="onInputBlur('clientSecret'); trimField('clientSecret'); blankSecret()" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                customerIdpForm.controls['clientSecret'].touched &&
                customerIdpForm.controls['clientSecret'].errors !== null &&
                !focusState()['name']
              ) {
                <mat-error id="client_secret_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i>
                  Client Secret is Required
                </mat-error>
              }
            </span>
          </div>

          <div class="span-all-cols">
            <div id="form_input_title_client_scopes" class="form-input-title">
              Scopes:
              <span matTooltip="Words are seperated by spaces" [matTooltipShowDelay]="500">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
            <mat-form-field
              id="form_field_client_scopes"
              class="form-field-custom form-field-input">
              <input
                matInput
                id="form_field_input_client_scopes"
                class="shared-input-field"
                formControlName="scopes"
                autocomplete="off"
                (focus)="onInputFocus('scopes')"
                (blur)="onInputBlur('scopes'); trimField('scopes')" />
            </mat-form-field>
            <span class="error-space-holder"> </span>
          </div>

          <div class="span-all-cols">
            <div id="form_input_title_prompt" class="form-input-title">Prompt:</div>
            <mat-form-field id="prompt_field" class="form-field-custom add-edit-dropdown">
              <mat-select id="prompt_select" placeholder="Select Prompt" formControlName="prompt">
                @for (option of promptOptions; track option.value) {
                  <mat-option id="prompt_option{{ option }}" [value]="option.value">
                    {{ option.label }} - {{ option.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="buttons-row span-all-cols">
            <button
              mat-button
              id="customers_add_edit_cancel"
              class="add-edit-button white-button"
              routerLink="/customers">
              Cancel
            </button>
            <button
              mat-button
              id="customers_add_edit_save"
              class="add-edit-button save-button"
              [ngClass]="{ 'invalid-button': !customerIdpForm.valid }"
              (click)="onSubmit()">
              Save
            </button>
          </div>
        </form>
      }
      @if (formPrepareError()) {
        <app-form-error class="higher-display" />
      } @else if (loading()) {
        <app-loading-spinner class="higher-display" />
      }
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
